// Third party packages
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
import * as i2 from "@ngx-translate/core";
var HelperService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function HelperService(toastrService, translateService) {
        this.toastrService = toastrService;
        this.translateService = translateService;
    }
    /**
     * Emit a toastr notification with given data
     *
     * @since 1.0.0
     *
     * @param error Emitted error
     * @param ?type If we want to override the error data, here
     * we must provide a toastr notification type 'error' or 'success'
     * @param ?message Override error message
     * @param ?title  Override error title
     * @returns Observable<boolean>
     */
    HelperService.prototype.handleError = function (error, type, message, title) {
        var _this = this;
        console.warn("handleError()", error);
        if (typeof type !== "undefined" && typeof message !== "undefined") {
            if (type === "error") {
                if (typeof title !== "undefined") {
                    this.toastrService.error(message, title);
                    return of(false);
                }
                this.toastrService.error(message);
                return of(false);
            }
            if (type === "success") {
                if (typeof title !== "undefined") {
                    this.toastrService.success(message, title);
                    return of(false);
                }
                this.toastrService.success(message);
                return of(false);
            }
        }
        if (error.data) {
            console.warn("1");
            Object.keys(error.data).forEach(function (key) {
                _this.toastrService.error(error.data[key].msg);
            });
            return of(false);
        }
        if (typeof error.error !== "undefined" && error.error.data) {
            console.warn("2");
            Object.keys(error.error.data).forEach(function (key) {
                // this.toastrService.error(error.error.data[key].msg, `Error in ${error.error.data[key].param}`);
                _this.toastrService.error(error.error.data[key].msg);
            });
            return of(false);
        }
        if (typeof error.error !== "undefined" && error.error.message) {
            console.warn("3");
            this.toastrService.error(error.error.message, this.translateService.instant("common.words.warning"));
            return of(false);
        }
        if (error.message) {
            console.warn("4");
            this.toastrService.error(error.message);
            return of(false);
        }
        // Generic error message
        console.warn("5");
        this.toastrService.error(this.translateService.instant("common.errors.server_down"), this.translateService.instant("common.words.error"));
        return of(false);
    };
    /**
     * Parse error coming from an httpRequest made
     * with { responseType: blob }
     *
     * @see https://stackoverflow.com/questions/48500822/how-to-handle-error-for-response-type-blob-in-httprequest
     *
     * @since 1.0.0
     */
    HelperService.prototype.parseErrorBlob = function (err) {
        var reader = new FileReader();
        var obs = new Observable(function (observer) {
            reader.onloadend = function (e) {
                observer.error(JSON.parse(reader.result.toString()));
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    };
    /**
     * Handle back-end errors showing them under the
     * appropriate form-control in given form instance
     *
     * @since 1.0.0
     */
    HelperService.prototype.handleFormError = function (form, err) {
        var _this = this;
        console.warn("handleFormError()", form, err);
        var errors = [];
        // Check data is defined
        if (typeof err.error === "undefined" ||
            typeof err.error.data === "undefined") {
            console.warn("err.error.data is undefined");
            this.handleError(err); // Fall back to toastr
            return;
        }
        // Convert data object to array
        Object.keys(err.error.data).forEach(function (key) {
            errors.push(err.error.data[key]);
        });
        // Set form invalid
        errors.forEach(function (error) {
            if (typeof form.controls[error.param] !== "undefined") {
                form.get(error.param).markAsTouched();
                form.get(error.param).markAsDirty();
                form.get(error.param).setErrors(error.msg);
            }
            else {
                // Ok, so form field is undefined, looks like back-end
                // found an error on a field that is missing in the front-end
                // This generally happends when we forgot a field on the
                // front-end. Let's show a nice toastr notification
                _this.toastrService.error(error.msg + ": " + error.param);
            }
        });
    };
    /**
     * Handle invalid status of form controls setting
     * dirty and touched class to those form controls
     *
     * @since 1.0.0
     */
    HelperService.prototype.handleFormInvalid = function (form) {
        console.warn("handleFormInvalid()", form);
        Object.keys(form.controls).forEach(function (controlKey) {
            var control = form.get(controlKey);
            if (control.invalid) {
                console.warn("Make control " + controlKey + " dirty()");
                control.markAsDirty();
                control.markAsTouched();
                control.setErrors({
                    "back-end": "booh" // @todo: translate
                });
            }
        });
    };
    /**
     * Check if given value is in string type or not
     *
     * @since 1.0.0
     */
    HelperService.prototype.isString = function (x) {
        return Object.prototype.toString.call(x) === "[object String]";
    };
    /**
     * Check if given form control is required or not
     *
     * @since 1.0.0
     *
     * @param control form control to check
     * @returns boolean True if it's required, false otherwhise.
     */
    HelperService.prototype.controlIsRequired = function (control) {
        if (typeof control === "undefined" ||
            typeof control.validator !== "function") {
            return false;
        }
        var validator = control.validator({});
        if (validator && validator.required) {
            return true;
        }
        return false;
    };
    /**
     * Generate an appropriate error message starting from given data
     *
     * @since 1.0.0
     */
    HelperService.prototype.getErrorMessage = function (key, value) {
        console.warn("key: " + key + " has error with value", value);
        var message = "";
        switch (key) {
            case "required":
                message = this.translateService.instant("common.errors.field_is_required");
                break;
            case "email":
                message = this.translateService.instant("common.errors.invalid_email_address");
                break;
            case "minlength":
                message = this.translateService.instant("common.errors.min_length_string", { minLength: value.requiredLength });
                break;
            case "maxlength":
                message = this.translateService.instant("common.errors.max_length_string", { maxLength: value.requiredLength });
                break;
            case "back-end":
                message = value.msg;
                break;
            default:
                message = this.translateService.instant("common.errors.generic_invalid_field");
                break;
        }
        return message;
    };
    /**
     * Format given address object and return it
     * as a string
     *
     * @since 1.0.0
     */
    HelperService.prototype.getFormattedAddress = function (address) {
        if (!address ||
            !address.route ||
            // !address.streetNumber ||
            !address.postalCode
        // ||
        // !address.city ||
        // !(address.countryCodeTwo || address.countryCode)
        ) {
            return "";
        }
        var countryCode = address.countryCodeTwo ? ", " + address.countryCodeTwo : (address.countryCode ? ", " + address.countryCode : '');
        var addressString = address.route + " " + address.streetNumber + ", " + address.postalCode + " " + address.city + countryCode;
        return addressString;
    };
    /**
     * Handle back-end errors coming from a ngx-formly form
     * and set the errors to the form (they will than be showed
     * as mat-error)
     *
     * @since 1.0.0
     */
    HelperService.prototype.handleFormlyError = function (form, err) {
        var _this = this;
        var errors = [];
        // Check data is defined
        if (typeof err.error === "undefined" ||
            typeof err.error.data === "undefined") {
            console.warn("err.error.data is undefined");
            this.handleError(err); // Fall back to toastr
            return;
        }
        // Set custom back-end errors to the form
        Object.keys(err.error.data).forEach(function (key) {
            if (form.get(key)) {
                // Standard controls
                form.get(key).markAsTouched();
                form.get(key).markAsDirty();
                console.warn("ERR_TEXT: ", err.error.data[key]);
                form.get(key).setErrors({
                    "server-error": err.error.data[key].msg
                });
            }
            else if (key.toLowerCase().includes("address")) {
                // Google Autocomplete controls
                // const targetKey1 = key.split('.')[0];
                // const targetKey2 = `${key.split('.')[0]}_`;
                // // form.get(targetKey1).markAsTouched();
                // // form.get(targetKey1).markAsDirty();
                // form.get(targetKey1).setErrors({
                //   'other': err.error.data[key],
                // });
                // // form.get(targetKey2).markAsTouched();
                // // form.get(targetKey2).markAsDirty();
                // form.get(targetKey2).setErrors({
                //   'other': err.error.data[key],
                // });
            }
            else {
                // Fall back
                console.warn("fallback", err.error.data[key].msg + ": " + err.error.data[key].param);
                // Ok, so form field is undefined, looks like back-end
                // found an error on a field that is missing in the front-end
                // This generally happends when we forgot a field on the
                // front-end. Let's show a nice toastr notification
                _this.toastrService.error(err.error.data[key].msg + ": " + err.error.data[key].param);
            }
        });
    };
    /**
     * Check if a document's "data" field is populated, meaning the document
     * has been actually uploaded/compiled (not just declared as mandatory).
     * Requires both the data object and its barCode to be present.
     *
     * @since 1.0.0
     *
     * @param data The "data" field of a flat document item (AllDocsInterface/DisplayedDocsInterface)
     * @returns boolean True if the document data is populated, false otherwise.
     */
    HelperService.prototype.isDocumentDataPopulated = function (data) {
        return !!(data && data.barCode);
    };
    HelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HelperService_Factory() { return new HelperService(i0.ɵɵinject(i1.ToastrService), i0.ɵɵinject(i2.TranslateService)); }, token: HelperService, providedIn: "root" });
    return HelperService;
}());
export { HelperService };
